export const DesignationValidator = (designationTitle) => [
    {
        name: "designation title",
        inputName: "designationTitleInput",
        value: designationTitle,
        validation: ['required'],
    },
]; 